import { useMemo } from 'react';
import { useProviderPlan, ProviderType } from '../api/useExternalProviderPlans';

export interface ProviderResource {
  url?: string;
  url_description?: string;
  name: string;
  description: string;
  image_url: string;
  tag_names: string[];
  providerType: ProviderType;
}

export const useProviderResources = (): ProviderResource[] => {
  const { providerPlan } = useProviderPlan();

  return useMemo(() => {
    if (!providerPlan) return [];

    return providerPlan.provider_types.flatMap((providerType) => {
      const typeConfig = providerPlan.type_configs?.find((c) => c.provider_type === providerType);

      const name = typeConfig?.tile_name;
      const description = typeConfig?.tile_description;
      if (!name || !description) return [];

      return [
        {
          name,
          description,
          image_url: typeConfig?.tile_image_url ?? '',
          tag_names: typeConfig?.tile_tags ?? [],
          providerType,
        },
      ];
    });
  }, [providerPlan]);
};
